import { preload, setUpIntake, takeOver } from './intake';

// The content pages' only script (see intake.ts). The build lists the app's files on its tag, to fetch them early.
const zone = document.querySelector<HTMLElement>('[data-intake]');
const appFiles = document.querySelector<HTMLScriptElement>('script[data-app-files]')?.dataset.appFiles?.split(' ').filter(Boolean) ?? [];

if (zone?.dataset.app) {
  const appUrl = zone.dataset.app;
  setUpIntake(zone, {
    open: (files) => takeOver(files, appUrl, () => import('../boot')),
    warm: () => preload(appFiles),
  });
}
